/* SHFTY landing page: category filters, product dialog, drop sign-up pass, countdown,
   and add-to-cart for linked products once the sale is open. */
(function () {
  'use strict';

  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Drop pass (sign-up) ---------- */

  function findPass() {
    return document.querySelector('[data-shfty-pass]');
  }

  // Remember which piece the visitor asked about by adding a tag to the sign-up.
  function selectPiece(name, piece) {
    var pass = findPass();
    if (!pass) return;
    var tags = pass.querySelector('[data-pass-tags]');
    var watching = pass.querySelector('[data-pass-watching]');
    var label = pass.querySelector('[data-pass-piece]');
    if (!tags) return; // already signed up

    if (name && piece) {
      tags.value = tags.dataset.baseTags + ', notify-' + piece;
      if (label) label.textContent = name;
      if (watching) watching.hidden = false;
    } else {
      tags.value = tags.dataset.baseTags;
      if (watching) watching.hidden = true;
    }
  }

  function goToPass() {
    var pass = findPass();
    if (!pass) return false;
    var target = pass.querySelector('.pass') || pass;
    target.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'center' });
    var email = pass.querySelector('[data-pass-email]');
    if (email) {
      window.setTimeout(function () {
        try { email.focus({ preventScroll: true }); } catch (error) { email.focus(); }
      }, reducedMotion ? 0 : 500);
    }
    return true;
  }

  function initPass(pass) {
    if (!pass || pass.dataset.shftyReady) return;
    pass.dataset.shftyReady = 'true';

    var clear = pass.querySelector('[data-pass-clear]');
    if (clear) clear.addEventListener('click', function () { selectPiece(null, null); });

    pass.querySelectorAll('[data-countdown]').forEach(initCountdown);
  }

  function initCountdown(element) {
    var iso = String(element.dataset.countdown || '').replace(/([+-]\d{2})(\d{2})$/, '$1:$2');
    var target = Date.parse(iso);
    if (isNaN(target)) return;
    var row = element.closest('[data-countdown-row]');

    function pad(value) { return value < 10 ? '0' + value : String(value); }

    function tick() {
      var left = target - Date.now();
      if (left <= 0) {
        if (row) row.hidden = true;
        return false;
      }
      var days = Math.floor(left / 86400000);
      var hours = Math.floor((left % 86400000) / 3600000);
      var minutes = Math.floor((left % 3600000) / 60000);
      element.textContent = days + 'D ' + pad(hours) + 'H ' + pad(minutes) + 'M';
      if (row) row.hidden = false;
      return true;
    }

    if (tick()) {
      var timer = window.setInterval(function () { if (!tick()) window.clearInterval(timer); }, 30000);
    }
  }

  // "Get notified" links scroll to the pass and put the cursor in the email field.
  document.addEventListener('click', function (event) {
    var link = event.target.closest ? event.target.closest('[data-shfty-notify-link]') : null;
    if (!link) return;
    var href = link.getAttribute('href') || '';
    if (href.charAt(0) !== '#') return;
    if (goToPass()) event.preventDefault();
  });

  /* ---------- Cart (sale mode) ---------- */

  function updateCartCount(count) {
    document.querySelectorAll('[data-shfty-cart]').forEach(function (link) {
      var counter = link.querySelector('[data-shfty-cart-count]');
      if (counter) counter.textContent = String(count);
      link.hidden = false;
    });
  }

  function wireBuyForm(slot, root) {
    var form = slot.querySelector('form');
    if (!form) return;
    var button = form.querySelector('.buy-button');
    var status = slot.querySelector('.buy-status');
    var cartAddUrl = root.dataset.cartAddUrl;
    var cartUrl = root.dataset.cartUrl;
    if (!cartAddUrl || !window.fetch || !window.FormData) return; // plain form post still works

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var label = button ? button.textContent : '';
      if (button) button.disabled = true;
      if (status) status.textContent = '';

      fetch(cartAddUrl + '.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form)
      })
        .then(function (response) {
          return response.json().then(function (data) {
            if (!response.ok) throw new Error(data.description || data.message || 'Error');
            return data;
          });
        })
        .then(function () {
          if (status) {
            status.textContent = (root.dataset.addedLabel || 'Added to cart') + ' — ';
            var link = document.createElement('a');
            link.href = cartUrl;
            link.textContent = root.dataset.viewCartLabel || 'View cart';
            status.appendChild(link);
          }
          return fetch(cartUrl + '.js', { headers: { Accept: 'application/json' } })
            .then(function (response) { return response.json(); })
            .then(function (cart) { updateCartCount(cart.item_count); })
            .catch(function () {});
        })
        .catch(function (error) {
          if (status) status.textContent = error.message;
        })
        .then(function () {
          if (button) { button.disabled = false; button.textContent = label; }
        });
    });
  }

  /* ---------- Collection: filters and product dialog ---------- */

  function initCollection(root) {
    if (!root || root.dataset.shftyReady) return;
    root.dataset.shftyReady = 'true';

    var filters = root.querySelectorAll('.filter');
    var cards = root.querySelectorAll('.card');
    filters.forEach(function (filter) {
      filter.addEventListener('click', function () {
        var value = filter.dataset.filter;
        filters.forEach(function (item) { item.setAttribute('aria-pressed', String(item === filter)); });
        cards.forEach(function (card) { card.hidden = value !== 'all' && card.dataset.category !== value; });
      });
    });

    var dialog = root.querySelector('dialog');
    if (!dialog) return;
    var track = dialog.querySelector('[data-modal-track]');
    var thumbs = dialog.querySelector('[data-modal-thumbs]');
    var modalTitle = dialog.querySelector('[data-modal-title]');
    var modalMeta = dialog.querySelector('[data-modal-meta]');
    var modalBuy = dialog.querySelector('[data-modal-buy]');
    var modalFit = dialog.querySelector('[data-modal-fit]');
    var modalGuide = dialog.querySelector('[data-modal-guide]');
    var notifyButton = dialog.querySelector('[data-notify-button]');
    var modalSoon = dialog.querySelector('[data-modal-soon]');
    var modalDescription = dialog.querySelector('[data-modal-description]');
    var modalProductLink = dialog.querySelector('[data-modal-product-link]');
    var current = { name: '', piece: '' };
    var slideCount = 0;
    var activeIndex = 0;

    function setActive(index) {
      activeIndex = index;
      if (!thumbs) return;
      Array.prototype.forEach.call(thumbs.children, function (thumb, position) {
        if (position === index) thumb.setAttribute('aria-current', 'true');
        else thumb.removeAttribute('aria-current');
      });
    }

    function goTo(index, smooth) {
      if (!track || !slideCount) return;
      var next = Math.max(0, Math.min(slideCount - 1, index));
      track.scrollTo({ left: next * track.clientWidth, behavior: smooth && !reducedMotion ? 'smooth' : 'auto' });
      setActive(next);
    }

    // One slide per photo. A card with extra photos carries them in a <template data-gallery>.
    function buildGallery(card, button) {
      if (!track) return;
      track.innerHTML = '';
      if (thumbs) thumbs.innerHTML = '';

      var sources = [];
      var gallery = card ? card.querySelector('template[data-gallery]') : null;
      if (gallery) sources = Array.prototype.slice.call(gallery.content.querySelectorAll('img'));
      if (!sources.length) {
        var main = button.querySelector('img');
        if (main) sources = [main];
      }

      sources.forEach(function (source, index) {
        var slide = document.createElement('div');
        slide.className = 'modal-slide';
        var image = document.createElement('img');
        image.src = source.dataset.full || source.currentSrc || source.getAttribute('src');
        image.alt = source.alt;
        if (index > 0) image.loading = 'lazy';
        slide.appendChild(image);
        track.appendChild(slide);

        if (thumbs && sources.length > 1) {
          var thumb = document.createElement('button');
          thumb.type = 'button';
          thumb.className = 'modal-thumb';
          thumb.setAttribute('aria-label', (thumbs.dataset.label || 'Photo') + ' ' + (index + 1));
          var small = document.createElement('img');
          small.src = source.dataset.thumb || image.src;
          small.alt = '';
          thumb.appendChild(small);
          thumb.addEventListener('click', function () { goTo(index, true); });
          thumbs.appendChild(thumb);
        }
      });

      slideCount = sources.length;
      if (thumbs) thumbs.hidden = slideCount < 2;
    }

    if (track) {
      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          ticking = false;
          if (track.clientWidth) setActive(Math.round(track.scrollLeft / track.clientWidth));
        });
      });
    }

    dialog.addEventListener('keydown', function (event) {
      if (slideCount < 2) return;
      var tag = event.target && event.target.tagName;
      if (tag === 'INPUT' || tag === 'SELECT' || tag === 'TEXTAREA') return;
      if (event.key === 'ArrowRight') { event.preventDefault(); goTo(activeIndex + 1, true); }
      if (event.key === 'ArrowLeft') { event.preventDefault(); goTo(activeIndex - 1, true); }
    });

    function closeDialog() {
      if (typeof dialog.close === 'function') dialog.close();
      else dialog.removeAttribute('open');
    }

    root.querySelectorAll('.product-button').forEach(function (button) {
      if (button.tagName === 'A') return;
      button.addEventListener('click', function () {
        var card = button.closest('.card');
        buildGallery(card, button);
        modalTitle.innerHTML = '';
        var titleText = document.createElement('bdi');
        titleText.textContent = button.dataset.name || '';
        modalTitle.appendChild(titleText);
        modalMeta.textContent = button.dataset.meta;
        if (modalFit) {
          modalFit.textContent = button.dataset.fit || '';
          modalFit.hidden = !button.dataset.fit;
        }
        if (modalGuide) {
          modalGuide.innerHTML = '';
          var guide = button.dataset.guide ? root.querySelector('template[data-size-guide="' + button.dataset.guide + '"]') : null;
          if (guide) modalGuide.appendChild(guide.content.cloneNode(true));
        }
        current = { name: button.dataset.label || button.dataset.name || '', piece: button.dataset.piece || '' };

        if (modalDescription) {
          modalDescription.innerHTML = '';
          var descriptionTemplate = card.querySelector('template[data-description]');
          if (descriptionTemplate) modalDescription.appendChild(descriptionTemplate.content.cloneNode(true));
        }
        if (modalProductLink) {
          modalProductLink.innerHTML = '';
          var productLinkTemplate = card.querySelector('template[data-product-link]');
          if (productLinkTemplate) modalProductLink.appendChild(productLinkTemplate.content.cloneNode(true));
        }
        if (modalSoon) modalSoon.hidden = button.dataset.state === 'open' || (button.dataset.state !== 'coming_soon' && root.dataset.dropState === 'open');
        modalBuy.innerHTML = '';
        var template = card ? card.querySelector('template[data-buy]') : null;
        if (template) {
          modalBuy.appendChild(template.content.cloneNode(true));
          wireBuyForm(modalBuy, root);
        }

        if (typeof dialog.showModal === 'function') dialog.showModal();
        else dialog.setAttribute('open', '');
        if (track) track.scrollLeft = 0;
        setActive(0);
      });
    });

    if (notifyButton) {
      // Without a sign-up pass on the page there is nowhere to send the visitor.
      if (!findPass()) notifyButton.hidden = true;
      notifyButton.addEventListener('click', function () {
        closeDialog();
        selectPiece(current.name, current.piece);
        goToPass();
      });
    }

    var close = dialog.querySelector('.close');
    if (close) close.addEventListener('click', closeDialog);
    dialog.addEventListener('click', function (event) { if (event.target === dialog) closeDialog(); });
  }


  function rememberLook(root) {
    root.querySelectorAll('.card[data-shfty-look] .product-button[href]').forEach(function (link) {
      if (link.dataset.returnReady) return;
      link.dataset.returnReady = 'true';
      link.addEventListener('click', function (event) {
        if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        var card = link.closest('.card[data-shfty-look]');
        if (!card) return;
        try {
          sessionStorage.setItem('shfty-drop-last-look', JSON.stringify({
            look: card.dataset.shftyLook,
            page: location.pathname,
            cardTop: card.getBoundingClientRect().top,
            y: window.scrollY
          }));
        } catch (error) {}
      });
    });
  }

  function restoreDropPosition() {
    var url = new URL(location.href);
    var look = url.searchParams.get('shfty_return');
    if (!look) return;
    var root = document.querySelector('[data-shfty-collection]');
    if (!root) return;
    var matching = null;
    root.querySelectorAll('.card[data-shfty-look]').forEach(function (card) {
      if (card.dataset.shftyLook === look) matching = card;
    });
    var target = matching || root;
    var saved = null;
    try { saved = JSON.parse(sessionStorage.getItem('shfty-drop-last-look') || 'null'); } catch (error) {}
    function targetTop() {
      if (matching && saved && saved.look === look && saved.page === location.pathname && typeof saved.y === 'number') {
        return saved.y;
      }
      return Math.max(0, window.scrollY + target.getBoundingClientRect().top - 105);
    }
    var doc = document.documentElement;
    var before = doc.style.getPropertyValue('scroll-behavior');
    var priority = doc.style.getPropertyPriority('scroll-behavior');
    doc.style.setProperty('scroll-behavior', 'auto', 'important');
    function jump() { window.scrollTo({ top: targetTop(), left: 0, behavior: 'instant' }); }
    jump();
    requestAnimationFrame(jump);
    window.addEventListener('load', function () {
      jump();
      if (before) doc.style.setProperty('scroll-behavior', before, priority);
      else doc.style.removeProperty('scroll-behavior');
    }, { once: true });
    url.searchParams.delete('shfty_return');
    history.replaceState(history.state, '', url.pathname + url.search + url.hash);
  }

  function initAll(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-shfty-product]').forEach(function (page) {
      if (page.dataset.shftyReady) return;
      page.dataset.shftyReady = 'true';
      var select = page.querySelector('[data-product-variant]');
      if (!select) return;
      function updateVariant() {
        var option = select.options[select.selectedIndex];
        var submit = page.querySelector('[data-product-submit]');
        var price = page.querySelector('[data-product-price]');
        if (submit) submit.disabled = !option || option.dataset.available !== 'true';
        if (price && option) price.textContent = option.dataset.price;
        var url = new URL(window.location.href);
        url.searchParams.set('variant', select.value);
        window.history.replaceState({}, '', url);
      }
      select.addEventListener('change', updateVariant);
      updateVariant();
    });
    root.querySelectorAll('[data-shfty-pass]').forEach(initPass);
    root.querySelectorAll('[data-shfty-collection]').forEach(initCollection);
    rememberLook(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); restoreDropPosition(); });
  else { initAll(); restoreDropPosition(); }

  // Theme editor: re-wire a section after it is re-rendered.
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();

